var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3495_9353)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.57662 2.704C5.21012 1.568 5.52662 1 6.00012 1C6.47362 1 6.79012 1.568 7.42362 2.704L7.58762 2.998C7.76762 3.321 7.85762 3.4825 7.99762 3.589C8.13762 3.6955 8.31262 3.735 8.66262 3.814L8.98062 3.886C10.2106 4.1645 10.8251 4.3035 10.9716 4.774C11.1176 5.244 10.6986 5.7345 9.86012 6.715L9.64312 6.9685C9.40512 7.247 9.28562 7.3865 9.23212 7.5585C9.17862 7.731 9.19662 7.917 9.23262 8.2885L9.26562 8.627C9.39212 9.9355 9.45562 10.5895 9.07262 10.88C8.68962 11.171 8.11362 10.9055 6.96262 10.3755L6.66412 10.2385C6.33712 10.0875 6.17362 10.0125 6.00012 10.0125C5.82662 10.0125 5.66312 10.0875 5.33562 10.2385L5.03812 10.3755C3.88662 10.9055 3.31062 11.1705 2.92812 10.8805C2.54462 10.5895 2.60812 9.9355 2.73462 8.627L2.76762 8.289C2.80362 7.917 2.82162 7.731 2.76762 7.559C2.71462 7.3865 2.59512 7.247 2.35712 6.969L2.14012 6.715C1.30162 5.735 0.882617 5.2445 1.02862 4.774C1.17512 4.3035 1.79012 4.164 3.02012 3.886L3.33812 3.814C3.68762 3.735 3.86212 3.6955 4.00262 3.589C4.14262 3.4825 4.23262 3.321 4.41262 2.998L4.57662 2.704Z",
    fill: "#F6CA22",
    stroke: "#F6CA22",
    strokeWidth: 1.4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3495_9353"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.1db4c5e555815f27ca10da888bd5893c.svg";
export { ForwardRef as ReactComponent };